import React, { memo, useCallback } from 'react';

import Form from 'react-bootstrap/Form';

import i18n from '../messages.json';

const ARTICLE_TYPE = 'Article';
const DIRECT_URL_TYPE = 'DirectURL';

/**
 * Radio toggle between Article (attach an Arc article) and Direct URL (paste any URL).
 * Switching swaps the active variant but preserves the inactive one for the
 * session (handled by the parent's handleNotificationTypeChange callback —
 * passed in as `onChange` — which stashes/restores each input's value), so
 * flipping back and forth doesn't clear what the user already entered.
 *
 * Props
 *   typeNotification: 'Article' | 'DirectURL'
 *   onChange:         (name: 'Article' | 'DirectURL') => void
 */
const LinkTypeField = ({ typeNotification, onChange }) => {
  const handleArticleSelect = useCallback(() => onChange(ARTICLE_TYPE), [onChange]);
  const handleDirectUrlSelect = useCallback(() => onChange(DIRECT_URL_TYPE), [onChange]);

  return (
    <Form.Group className='notification-compose__type-toggle'>
      <Form.Label className='notification-compose__field-label'>
        {i18n.ink.notification.linkType.label}
      </Form.Label>
      <div>
        <Form.Check
          key='inline-Article'
          name='radio-link-type'
          checked={typeNotification === ARTICLE_TYPE}
          inline
          label={i18n.ink.notification.article.label}
          type='radio'
          onChange={handleArticleSelect}
          id='inline-Article'
        />
        <Form.Check
          key='inline-DirectURL'
          name='radio-link-type'
          checked={typeNotification === DIRECT_URL_TYPE}
          inline
          label={i18n.ink.notification.directUrl.label}
          type='radio'
          onChange={handleDirectUrlSelect}
          id='inline-DirectURL'
        />
      </div>
    </Form.Group>
  );
};

export default memo(LinkTypeField);
